import React from "react";
import { ArrowRight, Phone, Wifi, Share2, Smartphone } from "lucide-react";
import { Link } from "react-router-dom";

const ServicesSection = () => {
  const services = [
    {
      icon: Phone,
      category: "Centralino virtuale",
      title: "Office Smart",
      description: "Centralino virtuale per gestire efficacemente la comunicazione aziendale",
      features: ["Riduzione costi", "Gestione semplificata", "Scalabilità"],
      slug: "office-smart",
      backgroundImage: "https://images.unsplash.com/photo-1512428559087-560fa5ceab42"
    },
    {
      icon: Wifi,
      category: "Connettività",
      title: "Office Plus e Maxi", 
      description: "Fibra ottica fino a 1 Gigabit per velocità elevate",
      features: ["Videoconferenze HD", "Upload/Download veloce", "Connessione stabile"],
      slug: "office-plus",
      backgroundImage: "https://images.unsplash.com/photo-1548919185-abab5a27ca89"
    },
    {
      icon: Smartphone,
      category: "Mobile",
      title: "Super Unlimited",
      description: "Piano mobile con dati e chiamate illimitate per uso intensivo",
      features: ["Dati illimitati", "Chiamate e SMS illimitati", "5G incluso", "Roaming EU"],
      slug: "super-unlimited",
      backgroundImage: "https://images.unsplash.com/photo-1522125670776-3c7abb882bc2"
    },
    {
      icon: Share2,
      category: "Smartphone",
      title: "Dispositivi",
      description: "Smartphone del momento in vendita rateizzata o inclusi con piani tariffari",
      features: ["Apple e Android", "Rateizzazione 0%", "Inclusi nei piani", "Configurazione gratuita"],
      slug: "dispositivi",
      backgroundImage: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c"
    }
  ];

  return (
    <section className="bg-black text-white py-20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-6">
            Le nostre <span className="text-orange-500">soluzioni</span> per il tuo business
          </h2>
          <p className="text-xl text-gray-300">
            Oltre 10 anni di esperienza nel settore delle telecomunicazioni
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="relative bg-gray-800 rounded-lg overflow-hidden hover:bg-gray-700 transition-all duration-300 transform hover:scale-105 group min-h-[450px] flex flex-col"
            >
              {/* Background image with overlay */}
              <div 
                className="absolute inset-0 opacity-20 group-hover:opacity-30 transition-opacity duration-300"
                style={{
                  backgroundImage: `url('${service.backgroundImage}')`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat'
                }}
              ></div>
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/90 to-gray-800/60"></div>
              
              {/* Content */}
              <div className="relative z-10 p-6 flex flex-col h-full">
                {/* Category badge */}
                <div className="mb-3">
                  <span className="bg-orange-500/20 text-orange-400 px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wide">
                    {service.category}
                  </span>
                </div>
                
                {/* Icon */}
                <div className="mb-6">
                  <service.icon size={48} className="text-orange-400" />
                </div>
                
                {/* Title and description */}
                <h3 className="text-xl font-bold mb-4 text-white">{service.title}</h3>
                <p className="text-gray-300 mb-6">{service.description}</p>
                
                {/* Features */}
                <ul className="space-y-2 mb-6 flex-grow">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-400">
                      <div className="w-2 h-2 bg-orange-400 rounded-full mr-2 flex-shrink-0"></div>
                      {feature}
                    </li>
                  ))}
                </ul>
                
                {/* CTA Link - Fixed at bottom */}
                <div className="text-center mt-auto pt-4">
                  <Link 
                    to={service.slug === 'dispositivi' ? '/dispositivi' : `/servizio/${service.slug}`}
                    className="inline-flex items-center bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300 shadow-lg"
                  >
                    <span>Scopri di più</span>
                    <ArrowRight size={16} className="ml-2" />
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;